// extracted by mini-css-extract-plugin
module.exports = {"item":"YB0S2DbX","default":"HvJg96fT","productBlack":"QM0i1WRQ","outOfStock":"RuhgCxI3"};